export default "__VITE_ASSET__Dmr35J64__"